import { ChakraBox as Box } from "@airhelp/react-ui-components";
import type { BoxProps } from "@chakra-ui/react";
import { MAX_GRID_WIDTH } from "config/styleConsts";

export const Container = ({ maxWidth = MAX_GRID_WIDTH, children, ...props }: BoxProps) => (
  <Box mx="auto" maxW={maxWidth} {...props}>
    {children}
  </Box>
);
